import React, { Component } from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { tabulateImmutable } from "MODULES/shared/decorators";
import { repairOrderActions } from "MODULES/parts/actions";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { getConditionAbbrev, MOD_TO } from "MODULES/RepairOrders/constants";
import {
  CompanyName,
  LocationFlag,
  NoteTooltip
} from "MODULES/shared/components";
import {
  ID,
  QUANTITY,
  QUANTITY_RECEIVED,
  RETURN_TO_LOCATION_ID
} from "APP_ROOT/constants";
import { CONDITION, INVENTORY } from "MODULES/inventories/constants";
import {
  EXPECTED_DATE,
  LABOR_COST,
  PART_COST
} from "MODULES/SalesOrders/constants";
import { PART_NUMBER } from "MODULES/parts/constants";
import StatusBadges from "MODULES/RepairOrders/components/Detail/LineItems/StatusBadges";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import {
  ExchangeIcon,
  getCap,
  getExchange
} from "MODULES/RepairOrders/helpers";

function renderRow(lineItem, i, pushHistory) {
  const cap = getCap(lineItem);

  const exchangeGoneOutright = lineItem.get("exchange_gone_outright");
  return (
    <tr
      key={lineItem.get(ID)}
      className="clickable"
      onClick={() =>
        pushHistory(`/repair-orders/${lineItem.get("repair_order_uuid")}`)}
    >
      <td>{i + 1}</td>
      <td className={cap}>{lineItem.get("repair_order_code")}</td>
      <td className="text-center">
        {exchangeGoneOutright && <ExchangeIcon lineItem={lineItem.toJS()} />}
      </td>
      <td>{shortDate(lineItem.get("created_at"))}</td>
      <td>
        <CompanyName
          flattenedCompany={lineItem.toJS()}
          context="repair"
          truncateAt={25}
        />
      </td>
      <td>{lineItem.get("contact_name")}</td>
      <td>{lineItem.get("original_serial_number")}</td>
      <td>{lineItem.getIn([MOD_TO, PART_NUMBER])}</td>
      <td>{lineItem.get(QUANTITY)}</td>
      <td>{lineItem.get(QUANTITY_RECEIVED)}</td>
      <td>{getConditionAbbrev(lineItem.get("condition_sent"))}</td>
      <td>{getConditionAbbrev(lineItem.getIn([INVENTORY, CONDITION]))}</td>
      <td className="text-success text-center">{getExchange(lineItem)}</td>
      <MultiLocationFeature>
        <td className="text-center">
          <LocationFlag
            location={lineItem.get(RETURN_TO_LOCATION_ID)}
            unknownFlag={false}
          />
        </td>
      </MultiLocationFeature>
      <td>
        {<StatusBadges lineItem={lineItem.toJS()} />}
        {lineItem.toJS().inventory &&
          lineItem.toJS().inventory.status === "sales_order_created" && (
            <NoteTooltip
              placement="right"
              icon="fa-paper-plane"
              note="Pending Sale"
            />
          )}
      </td>
      <td>{shortDate(lineItem.get(EXPECTED_DATE))}</td>
      <td className="text-right">{dollars(lineItem.get(PART_COST))}</td>
      <td className="text-right">{dollars(lineItem.get(LABOR_COST))}</td>
      <td className="text-right">
        {dollars(lineItem.get("outside_labor_cost"))}
      </td>
      <td className="text-right">{dollars(lineItem.get("subtotal"))}</td>
    </tr>
  );
}

export class Table extends Component {
  static propTypes = {
    pushHistory: PropTypes.func.isRequired,
    setPageSize: PropTypes.func.isRequired,
    results: PropTypes.instanceOf(List).isRequired
  };

  componentWillMount() {
    this.props.setPageSize(25);
  }

  render() {
    const { pushHistory, results } = this.props;

    return (
      <table className="table table-striped table-hover table-numbered">
        <thead>
          <tr>
            <th />
            <th>RO #</th>
            <th>Exchange Gone Outright</th>
            <th>Date Created</th>
            <th>Repair Station</th>
            <th>Contact</th>
            <th>Serial #</th>
            <th>Mod To</th>
            <th>QTY</th>
            <th>Rec</th>
            <th>CD Sent</th>
            <th>Inv CD</th>
            <th className="text-center">Exch</th>
            <MultiLocationFeature>
              <th className="text-center">Return Store</th>
            </MultiLocationFeature>
            <th>Status</th>
            <th>Expected Date</th>
            <th className="text-right">Parts</th>
            <th className="text-right">Labor</th>
            <th className="text-right">Out. Labor</th>
            <th className="text-right">Total</th>
          </tr>
        </thead>
        <tbody>{results.map((r, i) => renderRow(r, i, pushHistory))}</tbody>
      </table>
    );
  }
}

export default connect(
  () => ({
    listId: "part/repairOrderLineItems"
  }),
  {
    pushHistory: push,
    setPageSize: repairOrderActions.pageActions.setPageSize
  }
)(tabulateImmutable(Table));



// WEBPACK FOOTER //
// ./app/modules/parts/components/RepairOrderLineItems/Table.jsx